// extracted by mini-css-extract-plugin
module.exports = {"section":"B_section__1RHV2"};